<template lang="pug">
    Panel(panelClassName="cclone-details")
        template(slot="header")
            sectionHeader(title="details")

        template(slot="content")
            //- TABS
            Tabs(:dataTabs="dataTabs" parent="builderCclones")
                //- CONTENT
                template(slot="content" v-if="activeTab === 'information'")

                    //- INFORMATIONS
                    section.detail-section
                        div.item-info
                            div.item-id {{ ccloneInfo.id }}
                            div.l-flex-row.l-align-center
                                div.item-status(:title="ccloneInfo.status" :class="itemCssClasses(ccloneInfo.status)")
                                div.item-label.css-cut-long-text(:title="ccloneInfo.label") {{ ccloneInfo.label }}

                    div.builder-cclone-content.scrollbar.is-scrollable
                        //- Details
                        section.detail-section
                            div.sub-header
                                div.sub-header-title Details
                            div.info-content
                                div.info-block
                                    div.label Owner
                                    div.value.css-cut-long-text(:title="ccloneInfo.email") {{ ccloneInfo.email }}
                                div.info-block
                                    div.label Active period
                                    div.value.l-flex-row.l-align-center
                                        div {{ _formatDateVerbose(ccloneInfo.start_date) }}
                                        svg-icon.icon-period-from-to(name='arrow-direction_right' size="small")
                                        div {{ _formatDateVerbose(ccloneInfo.end_date) }}
                                div.info-block
                                    div.label Creation date
                                    div.value {{ _formatDateVerbose(ccloneInfo.created_at) }}
                                div.info-block
                                    div.label Mode
                                    div.value {{ ccloneMode }}
                        //- Algorithm parameters
                        section.detail-section
                            div.sub-header
                                div.sub-header-title Algorithm parameters
                            div.info-content
                                div.info-block
                                    div.label Depth
                                    div.value {{ ccloneInfoDepth }}
                                div.info-block
                                    div.label Min. Bucket
                                    div.value {{ ccloneInfoMinBucket }}
                        //- Positive events
                        section.detail-section
                            div.sub-header
                                div.sub-header-title Positive events
                            div.info-content
                                div.info-block
                                    div.label Type
                                    div.value {{ ccloneInfoPositiveEventsType }}
                                div.info-block
                                    div.label Positive ID
                                    div.value {{ ccloneInfoPositiveEventsIds }}
                                div.info-block
                                    div.label Max volume
                                    div.value {{ ccloneInfo.max_positive_event }}
                                div.info-block
                                    div.label Volume
                                    div.value {{ ccloneInfoVolume }}
                                div.info-block
                                    div.label Criteria
                                    div.value {{ ccloneInfo.positive_events }}
                        //- Negative events
                        section.detail-section
                            div.sub-header
                                div.sub-header-title Negative events
                            div.info-content
                                div.info-block
                                    div.label Type
                                    div.value {{ ccloneInfoUniverseType }}
                                div.info-block
                                    div.label Negative ID
                                    div.value {{ ccloneInfoUniverseIds }}
                                div.info-block
                                    div.label Max negative events
                                    div.value {{ ccloneInfo.max_negative_event }}
                                div.info-block
                                    div.label real negative events
                                    div.value {{ ccloneInfoRealNegativeEvents }}
                        //- 3rd party
                        section.detail-section(v-if="has3rdPartyMode")
                            div.sub-header.l-flex-row--between
                                div.sub-header-title 3rd party
                            div.info-content
                                div.info-block
                                    div.label Cluster only
                                    div.value {{ ccloneInfoClusterOnly }}
                                div.info-block
                                    div.label Profile versioned
                                    div.value {{ ccloneInfoIsProfileVersioned }}


                template(slot="content" v-if="activeTab === 'audiences'")
                    div.builder-content.builder-volume.scrollbar.is-scrollable
                        div(v-if="isLoading")
                            div.content
                                div.stripe.medium-stripe.title
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                            div.content
                                div.stripe.medium-stripe.title
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                            div.content
                                div.stripe.medium-stripe.title
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                                div.stripe.small-stripe.category
                        div(v-else-if="noAudience")
                            span There is no audience for this cclone
                        div.item-audience.l-flex-row.l-align-center(
                            v-else
                            v-for="audience in audienceCcloneList" :key="audience.id"
                            :class="{'no-link': !hasUserAccessToMonitoring}"
                            @click="goToAudience(audience.id)")
                            div.item-audience-id {{ audience.id }}
                            div.item-audience-label.flex-1(:title="audience.label") {{ audience.label }}
                            svg-icon(
                                v-if="hasUserAccessToMonitoring"
                                title="go to monitoring"
                                name='go' size="small")

</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapGetters, mapMutations } from 'vuex'

import { isNull, isEmpty, isNil, head, filter } from 'lodash'

import helpers from '@/store/data/cclone/helpers'

import Panel from '@/components/common/Panel'
import SectionHeader from '@/components/common/SectionHeader'
import Tabs from '@/components/common/Tabs'

import { formatDateVerbose } from '@/utils/helpers'

export default {
    name: 'CCloneDetails',
    components: {
        Panel,
        SectionHeader,
        Tabs
    },

    props: {
        ccloneInfo: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return {
            dataTabs: [{ label: 'information' }, { label: 'audiences' }]
        }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId
        }),
        ...mapState('ui/cclone', {
            selectedCcloneId: state => state.selectedCcloneId
        }),
        ...mapState('ui/builder', {
            activeTab: state => state.cclone.activeTab
        }),
        ...mapGetters('data/audience', ['getAudiencesCclone']),
        ...mapGetters('account', ['getAccessToMonitoring']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        isLoading() {
            return !this.criteriaListIsReady
        },
        noAudience() {
            return this.criteriaListIsReady && isEmpty(this.audienceCcloneList)
        },

        // Audiences from cclone
        audienceCcloneList() {
            return filter(this.getAudiencesCclone, item => item.strong_classifiers_family_id === this.selectedCcloneId)
        },

        ccloneMode() {
            let cmode = ''
            if (this.ccloneInfo.settings.hasOwnProperty('3rdParty') && this.ccloneInfo.settings.hasOwnProperty('1stParty')) cmode = '1st and 3rd Party'
            else if (this.ccloneInfo.settings.hasOwnProperty('3rdParty')) cmode = '3rd Party'
            else if (this.ccloneInfo.settings.hasOwnProperty('1stParty')) cmode = '1st Party'
            return cmode
        },
        ccloneInfoDepth() {
            return JSON.parse(this.ccloneInfo.model_params)['maxdepth']
        },
        ccloneInfoMinBucket() {
            return JSON.parse(this.ccloneInfo.model_params)['minbucket']
        },
        ccloneInfoPositiveEventsType() {
            return helpers.getCcloneInfo(this.ccloneInfo.positive_events, 'type')
        },
        ccloneInfoPositiveEventsIds() {
            const _ccloneInfoPositiveEventsIds = helpers.getCcloneInfo(this.ccloneInfo.positive_events, 'ids')
            return _ccloneInfoPositiveEventsIds.length >= 1 && typeof _ccloneInfoPositiveEventsIds === 'object' ? head(_ccloneInfoPositiveEventsIds) : '-'
        },
        ccloneInfoUniverse() {
            return this.ccloneInfo.negative_events !== '' ? helpers.getCcloneInfo(this.ccloneInfo.negative_events) : {}
        },
        ccloneInfoUniverseType() {
            return !isEmpty(this.ccloneInfoUniverse) && typeof this.ccloneInfoUniverse === 'object'
                ? this.ccloneInfoUniverse['type']
                : this.has3rdPartyMode
                    ? 'Full database'
                    : '1st Party Universe'
        },
        ccloneInfoUniverseIds() {
            return !isEmpty(this.ccloneInfoUniverse) && typeof this.ccloneInfoUniverse === 'object' ? head(this.ccloneInfoUniverse['ids']) : '-'
        },
        has3rdPartyMode() {
            return this.ccloneInfo.settings.hasOwnProperty('3rdParty')
        },
        ccloneInfoClusterOnly() {
            return this.ccloneInfo.settings['3rdParty'].cluster_only ? 'Yes' : 'No'
        },
        ccloneInfoIsProfileVersioned() {
            return this.ccloneInfo.settings['3rdParty'].is_profile_versioned ? 'Yes' : 'No'
        },
        ccloneInfoVolume() {
            return isNil(this.ccloneInfo['scf_raw_data_result']) ? 'N/A' : this.ccloneInfo['scf_raw_data_result']['non_empty_positives']
        },
        ccloneInfoRealNegativeEvents() {
            return isNil(this.ccloneInfo['scf_raw_data_result']) ? 'N/A' : this.ccloneInfo['scf_raw_data_result']['non_empty_negatives']
        },

        hasUserAccessToMonitoring() {
            return this.getAccessToMonitoring()
        }
    },

    methods: {
        ...mapMutations('ui/monitoring', ['setSelectedRow', 'setActiveTab', 'setIsAudienceCcloneTargeted']),

        itemCssClasses(element) {
            let cssClasses = ''
            if (element === 'waiting') cssClasses += ' is-waiting'
            if (element === 'running') cssClasses += ' is-running'
            if (element === 'available') cssClasses += ' is-available'
            if (element === 'failed') cssClasses += ' is-failed'

            return cssClasses
        },

        _formatDateVerbose(date) {
            return formatDateVerbose(date)
        },

        formatCcloneEvents(ccloneEvent, key, eventType) {
            // Check if it's based on a former cclone or a new one
            let type_of
            try {
                const tmp = JSON.parse(ccloneEvent)
                if (isNull(ccloneEvent)) type_of = null
                // new one
                if (typeof tmp === 'object' && !isNull(ccloneEvent)) type_of = 'object'
            } catch {
                // former one
                type_of = 'string'
            }

            // Positive or Negative Events Type
            if (key === 'type') {
                if (type_of === 'string' || isNull(type_of)) {
                    return eventType === 'positive' ? ccloneEvent : isEmpty(ccloneEvent) || isNull(ccloneEvent) ? 'Full database' : ccloneEvent
                } else {
                    const obj = JSON.parse(ccloneEvent)
                    return obj['type']
                }
            }

            // Positive or Negative Events Ids
            if (key === 'ids') {
                if (type_of === 'string' || isNull(type_of)) return '-'
                else {
                    const obj = JSON.parse(ccloneEvent)
                    return obj['ids'].join()
                }
            }
            return false
        },

        goToAudience(audienceId) {
            if (this.hasUserAccessToMonitoring) {
                this.setSelectedRow({ rowId: audienceId, from: 'other-page' })
                this.setIsAudienceCcloneTargeted({ value: true })
                this.setActiveTab({ tab: 'information' })
                this.$router.push({ path: '/' + this.accountId + '/monitoring' })
            }
        }
    }
}
</script>
